import { Bounce, toast } from "react-toastify";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
export const ToastError = (errorMessage) => {
  toast.error(`${errorMessage}`, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    toastId: errorMessage, // Prevent duplicate toasts with same message
  });
};

export const ToastSuccess = (successMessage) => {
  toast.success(`${successMessage}`, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    toastId: successMessage, // Prevent duplicate toasts with same message
  });
};

export const ToastInfo = (infoMessage) => {
  toast.info(`${infoMessage}`, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    toastId: infoMessage, // Prevent duplicate toasts with same message
  });
};
